<template>
  <v-overlay :value="show && this.isLoading" z-index="1100">
    <FlexColumn :space="2" center>
      <v-progress-circular indeterminate :size="70" color="#ddd" />
      <FlexColumn :space="0" center style="color: #ddd">
        <Label v-if="message" :text="message" bold />
        <Label v-if="isLongLoading" text="読み込みが長すぎる場合は、お手数ですが再読込してみてください" />
      </FlexColumn>
    </FlexColumn>
  </v-overlay>
</template>

<script>
  import FlexColumn from '../atoms/FlexColumn'
  import Label from '../atoms/Label'
  export default {
    name: "Loading",
    components: { Label, FlexColumn },
    data() {
      return {
        loadingFunc: undefined, // 一瞬読み込み表示待ちファンクション用
        isLoading: false,
        
        longLoadingFunc: undefined, // 読み込みが長い場合の、Timeoutファンクション用
        isLongLoading: false,
      }
    },
    props: {
      show: {
        type: Boolean,
        required: true,
        default: false
      },
      message: {
        type: String,
        default: undefined,
      }
    },
    watch: {
      /** 一瞬で読み込みが終わるものはオーバレイを非表示とする（一瞬暗くなってしまう）*/
      show: {
        handler (newValue) {
          if (newValue) {
            this.loadingFunc = setTimeout(() => {
              this.isLoading = true
            }, 200)
          } else {
            this.isLoading = false
            clearTimeout(this.loadingFunc)
          }
        },
        immediate: true
      },

      /** 読み込みに時間がかかりすぎている場合は、特別なメッセージを出す */
      message: {
        handler (newValue) {
          if (newValue) {
            this.longLoadingFunc = setTimeout(() => {
              this.isLongLoading = true
            }, 10000)
          } else {
            this.isLongLoading = false
            clearTimeout(this.longLoadingFunc)
          }
        },
        immediate: true
      }
    }
  }
</script>

<style scoped>

</style>